import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import { useRadioState, RadioGroup as ReakitRadioGroup } from 'reakit/Radio';
/**
 * WordPress dependencies
 */

import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import ButtonGroup from '../button-group';
import RadioContext from '../radio-context';

function RadioGroup(_ref, ref) {
  var label = _ref.label,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["label", "checked", "defaultChecked", "disabled", "onChange"]);

  var radioState = useRadioState({
    state: defaultChecked,
    baseId: props.id
  });

  var radioContext = _objectSpread(_objectSpread({}, radioState), {}, {
    disabled: disabled,
    // controlled or uncontrolled
    state: checked !== null && checked !== void 0 ? checked : radioState.state,
    setState: onChange !== null && onChange !== void 0 ? onChange : radioState.setState
  });

  return createElement(RadioContext.Provider, {
    value: radioContext
  }, createElement(ReakitRadioGroup, _extends({
    ref: ref,
    as: ButtonGroup,
    "aria-label": label
  }, radioState, props)));
}

export default forwardRef(RadioGroup);
//# sourceMappingURL=index.js.map